import { deleteTags, TagUpdateType, useUpdateTags } from '@ukpostbox/client-data';
import { Button, ColourStateSolid, Modal, useTranslation } from '@ukpostbox/frontend-framework';
import React from 'react';
import { DeleteTagModalType } from '../Types/TagTypes';

function DeleteTagModal(props: DeleteTagModalType) {
	const { t } = useTranslation();
	const updateTags = useUpdateTags();

	const DeleteTags = () => {
		deleteTags(props.selectedTags).then(() => {
			updateTags.mutate({
				newData: props.selectedTags,
				tagIds: props.selectedTags,
				updateType: TagUpdateType.DELETE,
			});

			if (props.actionedCallback) {
				props.actionedCallback();
			}
		});
	};

	return (
		<Modal
			title={t('settings.tags.actions.delete', { count: props.selectedTags.length })}
			isOpen={props.isOpen}
			closeCallback={() => props.closeCallback()}
		>
			<p>{t('messages.deleteConfirm')}</p>
			<Button
				title={t('actions.delete')}
				fullWidth
				colour={ColourStateSolid.Primary}
				onClick={() => DeleteTags()}
			/>
		</Modal>
	);
}

export default DeleteTagModal;
